import { render, staticRenderFns } from "./ManageTabMediation.vue?vue&type=template&id=f81e4708&"
import script from "./ManageTabMediation.vue?vue&type=script&lang=js&"
export * from "./ManageTabMediation.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/ManageTabMediation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports